export const QUESTION_TYPE = {
    SINGLE_PICK: 1,
    MULTI_PICK: 2,
    NUMERIC_GRID: 3,
} as const;

export const QuestionType = {
    [QUESTION_TYPE.SINGLE_PICK]: 'Single-Pick',
    [QUESTION_TYPE.MULTI_PICK]: 'Multi-Pick',
    [QUESTION_TYPE.NUMERIC_GRID]: 'Numeric Grid',
} as const;
